var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import Brushaway from '@components/Brushaway';
import TextInput from '@components/TextInput/TextInput';
import InputTextArea, { StyleVariant } from '@components/InputTextArea/InputTextArea';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { useCreateComponentQuestionSetMutation } from '../hooks/useComponentQuestionSetsMutations';
import './AddComponentQuestionModalStyles.scss';
const namespace = 'features.settings.component_questions';
export default function AddComponentQuestionModal({ isOpen, onClose }) {
    const createMutation = useCreateComponentQuestionSetMutation();
    const { control, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({
        defaultValues: {
            name: '',
            description: ''
        }
    });
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        const requestData = {
            name: data.name,
            description: data.description || undefined,
            active: true
        };
        try {
            yield createMutation.mutateAsync(requestData);
            handleClose();
        }
        catch (error) {
            // Error handling is done in the mutation hook via toast
            console.error('Failed to create component question set:', error);
        }
    });
    const handleClose = () => {
        reset({
            name: '',
            description: ''
        });
        onClose();
    };
    // Wrapper for form submit to handle void return type
    const handleFormSubmit = (e) => {
        void handleSubmit(onSubmit)(e);
    };
    // Wrapper for button click to handle void return type
    const handleButtonSubmit = () => {
        void handleSubmit(onSubmit)();
    };
    const isLoading = isSubmitting || createMutation.isLoading;
    return (React.createElement(Brushaway, { open: isOpen, title: translate('create_new_question_set', { namespace }), onClose: handleClose, isForm: true, customFooter: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleClose, disabled: isLoading }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { variant: "primary", onClick: handleButtonSubmit, disabled: isLoading }, isLoading ? translate('creating', { namespace }) : translate('create', { namespace: 'features.commons' }))) },
        React.createElement("div", { className: "add-component-question-modal" },
            React.createElement("form", { className: "add-component-question-form", onSubmit: handleFormSubmit },
                React.createElement("div", { className: "form-row" },
                    React.createElement(Controller, { name: "name", control: control, rules: { required: translate('name_required', { namespace }) }, render: ({ field }) => {
                            var _a;
                            return (React.createElement(TextInput, { value: field.value || '', name: field.name, onChange: field.onChange, onBlur: field.onBlur, label: translate('name', { namespace }), error: (_a = errors.name) === null || _a === void 0 ? void 0 : _a.message, required: true }));
                        } })),
                React.createElement("div", { className: "form-row" },
                    React.createElement(Controller, { name: "description", control: control, render: ({ field }) => (React.createElement(InputTextArea
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        , Object.assign({}, field, { label: translate('description_label', { namespace }), variant: StyleVariant.Light, buttonControlled: false }))) }))))));
}
